import { useState } from 'react'
import { UsersList, AdminUser } from '../components/UsersList'
import { UserEventsPanel } from '../components/UserEventsPanel'
import { Header } from '../../landing/components/Header'
import { Helmet } from 'react-helmet-async'

export default function AdminPage() {
  const [selectedUser, setSelectedUser] = useState<AdminUser | null>(null)

  return (
    <>
      <Helmet>
        <title>BackOffice | Punta Tech Meetup</title>
        <meta name="robots" content="noindex,nofollow" />
        <meta name="description" content="BackOffice de administración de usuarios y eventos." />
      </Helmet>
      <Header onSignInClick={() => {}} />
      <div className="max-w-8xl mt-20 mx-auto p-4 md:p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-semibold">BackOffice</h1>
          <p className="text-sm text-gray-500">Usuarios y sus eventos.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="md:col-span-1">
            <UsersList onSelect={setSelectedUser} selectedUserId={selectedUser?.id || null} />
          </div>
          <div className="md:col-span-2">
            {selectedUser ? (
              <UserEventsPanel user={{ id: selectedUser.id, name: selectedUser.name }} />
            ) : (
              <div className="border rounded-md p-3 bg-white text-sm text-gray-500">Selecciona un usuario para ver sus eventos</div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}



